import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { ButtonGroup } from 'components/qstrap'
import Button from './Button'

class RadioButton extends React.Component {
  onButtonClick = (e) => {
    const buttons = [].slice.call(document.getElementsByClassName('button'))
    buttons.map(elm => elm.classList.remove('active'))

    e.target.classList.add('active')
    e.target.value = e.target.getAttribute('value')
    this.props.handleChange(e)
  }

  render() {
    return (
      <div>
        <ButtonGroup className="radio-buttons">
          {this.props.selectOptions.map((opt) => {
            const classNames = classnames('radio-buttons__option', { active: opt === this.props.defaultValue })
            return (
              <Button
                name="type"
                key={opt}
                value={opt}
                className={classNames}
                onClick={this.onButtonClick}
              >
                {opt}
              </Button>
            )
          })}
        </ButtonGroup>
      </div>
    )
  }
}

RadioButton.propTypes = {
  handleChange: PropTypes.func,
  selectOptions: PropTypes.array,
  defaultValue: PropTypes.string,
}

RadioButton.defaultProps = {
  selectOptions: [],
}

export default RadioButton
